import React, { useEffect, useState } from 'react';
import { ListViewItemProps, ListViewProps } from '../../type/listView';
import operationAPI from '../../api/operationApi';
import useLocationStore from '../../store/locatonStore';
import { encodeDateForUrl } from '../../utils/dateUtils';
import Loader from '../../assets/loader/Loader';

const ListItem: React.FC<ListViewItemProps> = ({
  name,
  pickupMax,
  pickupCurrent,
  dropoffMax,
  dropoffCurrent,
}) => {
  return (
    <div className="bg-backgroundColor-white   p-2 ml-2 mr-1 mb-2 border-b-2 border-customBorder-border">
      <h2
        className="
      flex justify-start
      text-sm font-semibold mb-2"
      >
        {name}
      </h2>
      <div className="flex justify-between items-center text-center space-x-4">
        <div>
          <p className="text-textColorGray text-sm">Pickup Max</p>
          <p className="text-textColor font-bold text-sm flex justify-start">
            {pickupCurrent}/
            <span className="text-text-primary">{pickupMax}</span>
          </p>
        </div>
        <div>
          <p className="text-textColorGray text-sm">Drop off Max</p>
          <p className="text-textColor font-bold text-sm flex  justify-start ">
            {dropoffCurrent}/
            <span className="text-text-primary">{dropoffMax}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

const ListView: React.FC<ListViewProps> = ({ date }) => {
  const { selectedLocation } = useLocationStore();
  const [data, setData] = useState<ListViewItemProps[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchTotalBookingsZoneWise = async () => {
      try {
        const response = await operationAPI.totalBookingsZoneWise(
          selectedLocation.OwnerId,
          encodeDateForUrl(date),
        );
        const transformedData = response?.data.map((zone: any) => ({
          id: zone?.zoneId.toString(),
          name: zone?.zoneName,
          pickupMax: zone?.maximum,
          pickupCurrent: zone?.pickup,
          dropoffMax: zone?.maximum,
          dropoffCurrent: zone?.dropoff,
        }));

        setData(transformedData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotalBookingsZoneWise();
  }, []);

  if (loading) {
    return <p className='flex justify-center align-middle'><Loader/></p>;
  }

  if (data.length === 0) {
    return <p>No data available.</p>;
  }

  return (
    <div className=" bg-backgroundColor-darkThemeColor ">
      <div className="max-h-96 overflow-y-auto bg-backgroundColor-white rounded-lg">
        {data.map((item) => (
          <ListItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};

export default ListView;
